import React, { useEffect } from "react";
import { useStore } from "../../../store/store";
import { convertDecimalToFraction } from "../../../util/formulas/convertDecimalToFraction";

function useWidthInputSelector(
  overall: number,
  minWidth: number,
  maxWidth: number
) {
  const handleErrMsgChange = useStore((state) => state.handleError);
  const errors = useStore((state) => state.errors);

  useEffect(() => {
    if (!overall) return;
    overall < minWidth || overall > maxWidth
      ? handleErrMsgChange(
          "widthErr",
          `Between ${convertDecimalToFraction(
            minWidth
          )}" and ${convertDecimalToFraction(maxWidth)}"`
        )
      : handleErrMsgChange("widthErr", "");
  }, [overall, minWidth, maxWidth]);

  return {
    widthErr: errors.widthErr,
  };
}

export default useWidthInputSelector;
